/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_LanguageInputs */



/**
* | output |
* | --- |
* | "Source Language" |
*
* @param {Source_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_language = /** @type {((inputs?: Source_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgangssprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua di origine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходный язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Língua de origem")
	return /** @type {LocalizedString} */ ("Source Language")
});